import { styled, forBrands, Theme, CSSObject } from '@core-ui/react-stitch';

interface BreakPoints {
  isSmall: boolean;
  isLarge: boolean;
  isMedium: boolean;
  isXLarge: boolean;
}

interface CardNameProps {
  bolder?: boolean;
  breakPoints?: BreakPoints;
}

const gapStyles = (): CSSObject => ({
  fontSize: '0.8rem',
});

const oldNavyStyles = (): CSSObject => ({
  fontSize: '0.8rem',
});

const getBrFontStyle = (breakPoints: BreakPoints | undefined): CSSObject => ({
  ...((breakPoints?.isSmall || breakPoints?.isMedium) && {
    fontSize: '0.6875rem',
    lineHeight: '0.75rem',
  }),
  ...(breakPoints?.isLarge && {
    fontSize: '0.8125rem',
    lineHeight: '0.8125rem',
  }),
  ...(breakPoints?.isXLarge && {
    fontSize: '0.9375rem',
    lineHeight: '1rem',
  }),
  fontWeight: 350,
  letterSpacing: '0.5px',
});

const getBrFontColor = (theme: Theme): CSSObject => ({
  color: theme.color.wh,
});

const bananaRepublicStyles = (
  theme: Theme,
  breakPoints: BreakPoints | undefined
): CSSObject => ({
  ...theme.brandFontAlt,
  fontSize: '0.8125rem',
  color: theme.color.b1,
  textTransform: 'uppercase',
  fontFamily: theme.brandFont.fontFamily,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  ...getBrFontColor(theme),
  ...getBrFontStyle(breakPoints),
});

const athletaStyles = (): CSSObject => ({
  fontVariantLigatures: 'none',
  fontSize: '0.8125rem',
  letterSpacing: '1px',
});

const defaultStyles = (): CSSObject => ({
  fontSize: '1rem',
  lineHeight: 1.125,
  letterSpacing: '0.5px',
});

const brandStyles = (
  theme: Theme,
  breakPoints: BreakPoints | undefined
): CSSObject =>
  forBrands(theme, {
    gap: gapStyles,
    gapfs: gapStyles,
    br: () => bananaRepublicStyles(theme, breakPoints),
    brfs: () => bananaRepublicStyles(theme, breakPoints),
    on: oldNavyStyles,
    at: athletaStyles,
    default: defaultStyles,
  }) as CSSObject;

const CardName = styled.div<CardNameProps>(
  ({ theme, breakPoints, bolder = false }) => ({
    ...theme.brandFont,
    color: theme.color.g2,
    lineHeight: 1.4,
    textTransform: 'none',
    fontWeight: bolder ? 'bold' : 'normal',
    ...brandStyles(theme, breakPoints),
  })
);

export default CardName;
